export const SESSION_STORAGE_KEYS = {
  ACCESS_TOKEN: 'rsAccessToken',
  EXPIRES_AT: 'rsExpiresAt',
  EXPIRES_AT_DATE: 'rsExpiresAtDate',
  IMPERSONATION_EMAIL: 'rsImpEmail',
  IS_UNIVERSAL_LOGIN: 'rsIsUniversalLogin',
  PROFILE: 'rsProfile',
  USER_TOKEN: 'rsToken',
  USER_TOKEN_CLAIMS: 'rsTokenClaims',
  REFRESH_TOKEN: 'rsRefreshToken',
  IMPERSONATION_MODE: 'rsMode',
  SIGNUP: 'rsSignup',
};
